import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationCountDirective } from './notification-count.directive';



@NgModule({
  declarations: [
    NotificationCountDirective,
  ],
  exports: [
    NotificationCountDirective,
  ],
  imports: [
    CommonModule,
  ]
})
export class KatchaNotificationModule { }
